import { Toolkit } from 'common-types'

interface IToolkitOrder {
	[key: string]: number
	Y: number
	A: number
	'1G': number
	V: number
	'2G': number
	T: number
	'1B': number
	'1Az': number
	'2B': number
	'2Az': number
	'1R': number
	'2R': number
	Wt: number
	Bl: number
	Bk: number
	'Bk - Varsity': number
	'Bk - Scholars': number
	Or: number
	Pu: number
}

const toolkitOrder: IToolkitOrder = {
	Y: 1,
	A: 1,
	'1G': 2,
	V: 2,
	'2G': 3,
	T: 3,
	'1B': 4,
	'1Az': 4,
	'2B': 5,
	'2Az': 5,
	'1R': 6,
	'2R': 7,
	Wt: 8,
	Bl: 8,
	Bk: 9,
	'Bk - Varsity': 9,
	'Bk - Scholars': 10,
	Or: 10,
	Pu: 11
}

function getSecondPartOfToolkit(name: string) {
	return name.split('|')[1].replace(/\s/g, '').replace('(Spanish)', '').replace('(TEKS)', '') as keyof IToolkitOrder
}

export const sortToolkits = (a: Toolkit, b: Toolkit) => {
	return toolkitOrder[getSecondPartOfToolkit(a.name)] - toolkitOrder[getSecondPartOfToolkit(b.name)]
}
